import React from 'react';
import { POPUP_STYLES } from '../../constants/popupStyles';

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  isLoading?: boolean;
  width?: string;
  compactHeader?: boolean;
  className?: string;
  titleClassName?: string;
  titleAlign?: 'left' | 'center' | 'right';
}

export const ModalWrapper: React.FC<ModalWrapperProps> = ({
  isOpen,
  onClose,
  title,
  children,
  isLoading = false,
  width,
  compactHeader = false,
  className = '',
  titleClassName,
  titleAlign = 'center',
}) => {
  if (!isOpen) return null;

  const modalClass = `${width
    ? POPUP_STYLES.modal.replace('max-w-md', width)
    : POPUP_STYLES.modal
  } ${className}`.trim();

  const headerContainerClass = compactHeader
    ? POPUP_STYLES.headerContainer.replace('pt-1 pb-5', 'pt-0 pb-2')
    : POPUP_STYLES.headerContainer;

  // Determine header alignment
  const alignmentClass = titleAlign === 'left'
    ? 'justify-start'
    : titleAlign === 'right'
    ? 'justify-end'
    : 'justify-center';

  const headerInnerClass = POPUP_STYLES.headerInner.replace('justify-center', alignmentClass);

  // Use custom title class or default
  const titleClass = titleClassName || POPUP_STYLES.title;

  return (
    <div className={POPUP_STYLES.container}>
      <div
        className={modalClass}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with Title and Close Button */}
        <div className={headerContainerClass}>
          <div className={headerInnerClass}>
            <h2 className={titleClass}>{title}</h2>
            <button
              onClick={onClose}
              className={POPUP_STYLES.closeButton}
              disabled={isLoading}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        {children}
      </div>
    </div>
  );
};
